export const INIT_RESOURCE_LIST = 'INIT_RESOURCE_LIST';
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE';

export default { INIT_RESOURCE_LIST, UPDATE_RESOURCE };
